/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus2 } from './entityStatus2';


export interface SmsClient { 
    id: string;
    anqClientId: number;
    anqUserId: number;
    creatorId?: string;
    email?: string;
    fullname?: string;
    userChannelType: number;
    systemId?: string;
    password?: string;
    defaultRouteName?: string;
    firstName?: string;
    isTelco: boolean;
    lastName?: string;
    username?: string;
    apiKey?: string;
    entityStatus: EntityStatus2;
    dateCreated: Date;
    countryName?: string;
    countryCode?: string;
    addressLocation?: string;
    isLocal: boolean;
}
